export default __webpack_public_path__ + "static/hero-e2ec67fbb6b0c55b4e30eb58305c181f.jpg";